<template>
  <div id="dicas-doc">
    <p class="txt-titulo" v-if="txtTitulo">{{txtTitulo}}</p>
    <div class="dicas">
      <div class="row">
        <div class="col-2">
          <img class="img-fluid mx-auto"
               src="@/assets/img/dicas-doc/ilustra_lampada.png"
               title="Coloque o documento em um lugar bem iluminado"
               alt="Coloque o documento em um lugar bem iluminado">
        </div>
        <div class="col-10">
          <p class="txt-subtitulo">Coloque o documento em um lugar bem iluminado</p>
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <img class="img-fluid mx-auto"
               src="@/assets/img/dicas-doc/ilustra_protecaodoc.png"
               title="Retire a proteção de plástico pra deixar os dados legíveis"
               alt="Retire a proteção de plástico pra deixar os dados legíveis">
        </div>
        <div class="col-10">
          <p class="txt-subtitulo">Retire a proteção de plástico pra deixar os dados legíveis</p>
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <img class="img-fluid mx-auto"
               src="@/assets/img/dicas-doc/ilustra_moldura.png"
               title="Centralize o documento dentro da moldura na tela"
               alt="Centralize o documento dentro da moldura na tela">
        </div>
        <div class="col-10">
          <p class="txt-subtitulo">Centralize o documento dentro da moldura na tela</p>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "DicasDoc",
  props:{
    txtTitulo:{type: String}
  }
}
</script>

<style scoped>
.dicas{
  margin-top: 3rem;
}
.dicas .row .col-2{
  padding-right: 0;
}
.dicas p{
  margin: 0;
}
.dicas p.txt-subtitulo{
  line-height: normal;
}
.dicas .row{
  margin-bottom: 2rem;
  padding-bottom: 0.5rem;
}
.dicas .row:nth-child(-n + 2){
  border-bottom: solid 1px #cccc;
}

@media (max-device-height: 640px) {
  .dicas img{
    width: 2.2rem;
    display: block;
    position: relative;
    margin: 0 auto;
  }
  .dicas{
    margin-top: 1.3rem;
  }
}
@media (max-device-height: 639px){
  .dicas img{
    width: 2.2rem;
    display: block;
    position: relative;
    margin: 0 auto;
  }
  .dicas{
    margin-top: 1.3rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/shared/DicasDoc.vue